import React from 'react';
import AtacamaPageHardcoded from './AtacamaPageHardcoded';
import './AtacamaPage.css';

const AtacamaPage: React.FC = () => {
  return <AtacamaPageHardcoded />;
};

export default AtacamaPage;